import React, { useState } from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Container,
} from 'reactstrap';


const Header = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);

    return (
    <>
        <Navbar color="dark" dark expand="lg">
            {/* <Container> */}
             <NavbarBrand href="/" className='text-font-family' style={{paddingTop: '0px'}}>cd /zauso-dev <span className='logo__cursor'> </span></NavbarBrand>
                <NavbarToggler onClick={toggle} />
                <Collapse isOpen={isOpen} navbar>
                <Nav className="mr-auto text-font-family" navbar>
                    <NavItem>
                      <NavLink href="/">Home</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/project">Projetos</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/books">Livros</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/blog">Blog</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/about">Sobre</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/contact">Contato</NavLink>
                    </NavItem>
                </Nav>
                </Collapse>
            {/* </Container> */}
        </Navbar>
    </>
    )
}

export default Header;